import { FC } from 'react'
import { AccountLayout } from '../components/layout/AccountLayout'
import { NewLeaseRequestContent } from '../components/management/leases/NewLeaseRequestContent'

export const NewLeaseRequestPage: FC = () => (
  <AccountLayout>
    <NewLeaseRequestContent />
  </AccountLayout>
)

export default NewLeaseRequestPage
